// Le pagine di modifica non hanno l'id nell'URL: leggono il documento popolato da location.state
// (come quando si clicca la matita nella lista).
const MODIFICA = {
  clienti: '/clienti/modifica',
  fornitori: '/fornitori/modifica',
  articoli: '/articoli/modifica',
  fatture: '/fatture/modifica',
  cantieri: '/cantieri/modifica',
  preventivi: '/preventivi/modifica',
  ordini: '/carrello'
}

// Preventivi fatturati/ecommerce e ordini non manuali non si modificano: si apre la lista evidenziandoli.
const LISTA = {
  preventivi: hit => ['/preventivi', { highlightPreventivo: hit._id, fromSearch: true }],
  ordini: hit => ['/ordini', { tipoOrdine: hit.campi?.tipo || 'fornitore', highlightOrders: [hit._id], fromSearch: true }]
}

export async function apriRisultato (hit, { navigate, Api }) {
  if (hit.azione === 'url') {
    navigate(`/board/${hit._id}`)
    return true
  }
  if (hit.azione === 'lista') {
    const [path, state] = LISTA[hit.tipo](hit)
    navigate(path, { state })
    return true
  }
  const res = await Api.get(`/search/${hit.tipo}/${hit._id}`)
  if (!res.ok || !res.data) return false
  navigate(MODIFICA[hit.tipo], { state: res.data })
  return true
}
